import Component from "gia/Component";
import { getCoords } from "../utils/utils";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.RAF = false;

    this.watcher();
  }

  calculate() {
    this.dimensions = getCoords(this.ref.text[0]);
    this.ref.border[0].style.width = `${this.dimensions.width}px`;
  }

  watcher() {
    this.RAF = requestAnimationFrame(() => {
      this.calculate();
      this.watcher();
    });
  }

  unmount() {
    cancelAnimationFrame(this.RAF);
  }
}
